import React from 'react';
import { ClockIcon, XIcon, CheckIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
const rows = [{
  before: 'Notti intere a cercare tutorial su Pinterest o YouTube.',
  after: 'Lezioni pronte sul tuo tablet in 2 clic.'
}, {
  before: 'Stress prima di ogni lezione per non sapere cosa proporre.',
  after: 'Sicurezza totale entrando in classe.'
}, {
  before: 'Spiegazioni confuse che gli alunni non seguono.',
  after: 'Supporti visivi per la LIM che incantano i bambini.'
}, {
  before: 'Frustrazione per una classe disordinata e poco motivata.',
  after: 'Progressione didattica chiara dalla 1ª alla 5ª.'
}];
export function ContrastSection() {
  return <section className="relative w-full bg-bg-main py-16 sm:py-24 px-4 overflow-hidden" data-id="element-110">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(249,115,22,0.08) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-111"></div>

      <div className="relative max-w-5xl mx-auto" data-id="element-112">
        {/* Section header */}
        <div className="text-center mb-10 sm:mb-14" data-id="element-113">
          <span className="inline-flex items-center gap-1.5 text-badge-red font-bold text-[11px] sm:text-xs uppercase tracking-[0.15em] bg-badge-red/10 border border-badge-red/20 px-3 py-1.5 rounded-full mb-4" data-id="element-114">
            <span className="w-1.5 h-1.5 rounded-full bg-badge-red animate-pulse-composited" data-id="element-115"></span>
            Il vero costo nascosto
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight leading-[1.1] max-w-3xl mx-auto" data-id="element-116">
            Smetti di pagare con il{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-300 via-primary to-orange-500" data-id="element-117">
              tuo tempo libero
            </span>
            .
          </h2>
        </div>

        {/* Time cost callout — redesigned with stat */}
        <div className="relative bg-gradient-to-br from-badge-red/10 to-badge-red/[0.03] border border-badge-red/30 rounded-2xl sm:rounded-3xl p-6 sm:p-10 mb-10 sm:mb-14 overflow-hidden" data-id="element-118">
          {/* Decorative clock */}
          <div className="absolute -right-6 -top-6 sm:-right-4 sm:-top-4 w-32 h-32 sm:w-40 sm:h-40 rounded-full bg-badge-red/5 flex items-center justify-center pointer-events-none" data-id="element-119">
            <ClockIcon className="w-16 h-16 sm:w-20 sm:h-20 text-badge-red/20" strokeWidth={1.5} data-id="element-120" />
          </div>

          <div className="relative flex flex-col sm:flex-row items-center sm:items-stretch gap-6 sm:gap-8" data-id="element-121">
            {/* Big stat */}
            <div className="flex-shrink-0 text-center sm:text-left sm:border-r sm:border-badge-red/20 sm:pr-8" data-id="element-122">
              <div className="text-5xl sm:text-7xl font-black text-badge-red leading-none tracking-tighter" data-id="element-123">
                100+
              </div>
              <div className="text-badge-red/80 font-bold text-xs sm:text-sm uppercase tracking-wider mt-2" data-id="element-124">
                ore perse all'anno
              </div>
            </div>

            {/* Copy */}
            <div className="flex-1 text-center sm:text-left" data-id="element-125">
              <p className="text-text-main text-base sm:text-xl font-semibold leading-relaxed" data-id="element-126">
                Progettare manualmente ogni lezione ti toglie da{' '}
                <span className="text-badge-red font-black" data-id="element-127">
                  2 a 4 ore a settimana
                </span>
                .
              </p>
              <p className="text-text-sec text-sm sm:text-base mt-2 sm:mt-3 leading-relaxed" data-id="element-128">
                Sono <span className="text-text-main font-bold" data-id="element-129">weekend</span>,{' '}
                <span className="text-text-main font-bold" data-id="element-130">serate</span> e{' '}
                <span className="text-text-main font-bold" data-id="element-131">
                  tempo in famiglia
                </span>{' '}
                che non tornano più indietro.
              </p>
            </div>
          </div>
        </div>

        {/* Comparison Card */}
        <div className="relative bg-bg-alt rounded-2xl sm:rounded-3xl shadow-2xl border border-border-light overflow-hidden" data-id="element-132">
          {/* Header */}
          <div className="grid grid-cols-2 border-b border-border-light relative" data-id="element-133">
            <div className="px-4 sm:px-8 py-4 sm:py-6 text-center md:text-left bg-badge-red/[0.08] border-r border-border-light" data-id="element-134">
              <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-135">
                <div className="w-7 h-7 rounded-full bg-badge-red/20 border border-badge-red/40 flex items-center justify-center flex-shrink-0" data-id="element-136">
                  <XIcon className="w-4 h-4 text-badge-red" strokeWidth={3} data-id="element-137" />
                </div>
                <div data-id="element-138">
                  <div className="font-black text-badge-red text-[11px] sm:text-sm uppercase tracking-wider leading-tight" data-id="element-139">
                    Senza Arte Pronta
                  </div>
                  <div className="text-text-sec text-[10px] sm:text-xs hidden sm:block mt-0.5" data-id="element-140">
                    Cosa ti costa oggi
                  </div>
                </div>
              </div>
            </div>
            <div className="px-4 sm:px-8 py-4 sm:py-6 text-center md:text-left bg-cta-green/[0.08]" data-id="element-141">
              <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-142">
                <div className="w-7 h-7 rounded-full bg-cta-green/20 border border-cta-green/40 flex items-center justify-center flex-shrink-0" data-id="element-143">
                  <CheckIcon className="w-4 h-4 text-cta-green" strokeWidth={3} data-id="element-144" />
                </div>
                <div data-id="element-145">
                  <div className="font-black text-cta-green text-[11px] sm:text-sm uppercase tracking-wider leading-tight" data-id="element-146">
                    Con Arte Pronta
                  </div>
                  <div className="text-text-sec text-[10px] sm:text-xs hidden sm:block mt-0.5" data-id="element-147">
                    La tua vita domani
                  </div>
                </div>
              </div>
            </div>

            {/* Center arrow badge — desktop only */}
            <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-bg-main border-2 border-primary/40 items-center justify-center shadow-[0_0_20px_rgba(249,115,22,0.3)] z-10" data-id="element-148">
              <ArrowRightIcon className="w-4 h-4 text-primary" strokeWidth={3} data-id="element-149" />
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-150">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-2 group transition-colors relative" data-id="element-151">
                {/* Before */}
                <div className="px-4 sm:px-8 py-5 sm:py-7 flex items-start gap-3 sm:gap-4 border-r border-border-light bg-black/20" data-id="element-152">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-badge-red/15 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-153">
                    <XIcon className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-badge-red" strokeWidth={3} data-id="element-154" />
                  </div>
                  <p className="text-text-sec text-sm sm:text-base leading-snug line-through decoration-badge-red/40 decoration-2" data-id="element-155">
                    {row.before}
                  </p>
                </div>

                {/* After */}
                <div className="px-4 sm:px-8 py-5 sm:py-7 flex items-start gap-3 sm:gap-4 bg-cta-green/[0.04] relative overflow-hidden" data-id="element-156">
                  <div className="absolute inset-0 bg-gradient-to-r from-cta-green/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-157"></div>
                  <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-cta-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-cta-green/40 relative z-10" data-id="element-158">
                    <CheckIcon className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-cta-green" strokeWidth={3} data-id="element-159" />
                  </div>
                  <p className="text-text-main text-sm sm:text-base font-semibold leading-snug relative z-10" data-id="element-160">
                    {row.after}
                  </p>
                </div>

                {/* Mobile arrow indicator between cells */}
                <div className="md:hidden absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-bg-main border-2 border-primary/40 flex items-center justify-center shadow-md pointer-events-none z-10" data-id="element-161">
                  <ArrowRightIcon className="w-3 h-3 text-primary" strokeWidth={3} data-id="element-162" />
                </div>
              </div>)}
          </div>
        </div>

        {/* Closing emotional line */}
        <div className="mt-8 sm:mt-12 text-center" data-id="element-163">
          <p className="inline-flex items-center gap-2 text-text-main text-base sm:text-lg font-bold" data-id="element-164">
            <SparklesIcon className="w-5 h-5 text-secondary" data-id="element-165" />
            <span data-id="element-166">
              Ricomincia ad amare il{' '}
              <span className="text-cta-green" data-id="element-167">lunedì mattina</span>.
            </span>
          </p>
        </div>
      </div>
    </section>;
}